import { Node, Rect, rectToBox } from "reactflow"
import { GraphNodeChange } from "./graphApplyChanges"

export const parentNodeDragChanges = (
  parent: Node,
  parentRect: Rect,
  node: Node,
  nodeRect: Rect,
): GraphNodeChange => {
  const change: GraphNodeChange = { id: parent.id }
  const parentBox = rectToBox(parentRect)
  const nodeBox = rectToBox(nodeRect)
  // keep the order or it will break first condition
  if (nodeBox.x < parentBox.x) {
    const left = Math.round(parentBox.x - nodeBox.x)
    leftExpandChanges(parent, left, change)
  }
  if (nodeBox.x2 > parentBox.x2) {
    const right = Math.round(nodeBox.x2 - parentBox.x2)
    rightExpandChanges(parent, right, change)
  }
  if (nodeBox.y < parentBox.y) {
    const top = Math.round(parentBox.y - nodeBox.y)
    topExpandChanges(parent, top, change)
  }
  if (nodeBox.y2 > parentBox.y2) {
    const bottom = Math.round(nodeBox.y2 - parentBox.y2)
    bottomExpandChanges(parent, bottom, change)
  }
  return change
}

const leftExpandChanges = (parent: Node, diff: number, change: GraphNodeChange): void => {
  change.position = { x: parent.position.x - diff, y: parent.position.y }
  change.size = { width: parent.width! + diff, height: parent.height! }
}

const rightExpandChanges = (parent: Node, diff: number, change: GraphNodeChange): void => {
  if (change.size) {
    change.size.width = parent.width! + diff
    return
  }
  change.size = { width: parent.width! + diff, height: parent.height! }
}

const topExpandChanges = (parent: Node, diff: number, change: GraphNodeChange): void => {
  if (change.position) {
    change.position.y = parent.position.y - diff
  } else {
    change.position = { x: parent.position.x, y: parent.position.y - diff }
  }
  if (change.size) {
    change.size.height = parent.height! + diff
  } else {
    change.size = { width: parent.width!, height: parent.height! + diff }
  }
}

const bottomExpandChanges = (parent: Node, diff: number, change: GraphNodeChange): void => {
  if (change.size) {
    change.size.height = parent.height! + diff
    return
  }
  change.size = { width: parent.width!, height: parent.height! + diff }
}
